"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var init = function () {
    var $smallVideo = $('.small-video');
    var activeClass = 'video-header__video--active';
    var $playButton = $('.play-btn');
    var $videoWrapper = $('.video-header');
    var $carousel = $('.mobile-carousel');
    $('.content-wrapper__slider div:first').addClass('activeBorder');
    var enableEvents = function () {
        owlCarousel();
        $smallVideo.on('click', changeVideo);
    };
    $playButton.on('click', function () {
        var video = $(this).siblings('.video-header').children('.video-header__video')[0];
        video.play();
        $videoWrapper.fadeIn();
        $(video).addClass(activeClass);
    });
    $videoWrapper.on('click', function () {
        var video = $(this).children('.video-header__video')[0];
        video.pause();
        $videoWrapper.fadeOut();
        $(video).removeClass(activeClass);
    });
    var changeVideo = function () {
        var number = $(this).data('slider');
        var upperContent = $(this).parents('.row').children('.upper-content');
        $smallVideo.removeClass('activeBorder');
        $(this).toggleClass('activeBorder');
        $('.upper-content__video').fadeOut();
        $('.upper-content__description').fadeOut();
        upperContent.find("[data-video='".concat(number, "']")).delay(300).fadeIn();
        upperContent.find("[data-text='".concat(number, "']")).delay(300).fadeIn();
    };
    var owlCarousel = function () {
        $carousel.owlCarousel({
            items: 1,
            slideSpeed: 2000,
            nav: false,
            autoplay: false,
            dots: true,
            loop: false
        });
    };
    $(window).on('load', enableEvents);
};
exports.init = init;
